import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const SearchIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M16.6 18a9 9 0 1 1 1.4-1.4l3.7 3.7a1 1 0 0 1-1.4 1.4L16.6 18ZM4 11a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default SearchIcon;
